const unisATSRoutes = {
  MAIN: '/login',
  VACANCIES: '/vacancies',
  COMPANIES: '/company',
  FORMVACANCYADD: '/vacancy/job-form',
  ATS: '/applicant-tracking/:vacancyId',
  ForgotPass: '/forgot-pass',
};

export default unisATSRoutes;
